(() => {
  const dataElement = document.getElementById('stark-enhancements-data');
  let config = {};

  try {
    config = JSON.parse(dataElement?.textContent || '{}');
  } catch (error) {
    console.warn('[Stark enhancements] Invalid configuration.', error);
  }

  const originalFetch = window.fetch.bind(window);

  window.fetch = (resource, options) => {
    try {
      const rawUrl =
        typeof resource === 'string'
          ? resource
          : resource instanceof Request
            ? resource.url
            : String(resource);

      const url = new URL(rawUrl, window.location.origin);

      if (url.origin === window.location.origin && url.pathname.includes('/search/suggest')) {
        url.searchParams.set(
          'resources[options][fields]',
          'title,product_type,variants.title,vendor,variants.sku'
        );

        resource = resource instanceof Request ? new Request(url.toString(), resource) : url.toString();
      }
    } catch (error) {
      console.warn('[Stark enhancements] Could not extend predictive search.', error);
    }

    return originalFetch(resource, options);
  };

  const socialIcons = {
    instagram:
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7.75 2h8.5A5.76 5.76 0 0 1 22 7.75v8.5A5.76 5.76 0 0 1 16.25 22h-8.5A5.76 5.76 0 0 1 2 16.25v-8.5A5.76 5.76 0 0 1 7.75 2Zm0 2A3.75 3.75 0 0 0 4 7.75v8.5A3.75 3.75 0 0 0 7.75 20h8.5A3.75 3.75 0 0 0 20 16.25v-8.5A3.75 3.75 0 0 0 16.25 4h-8.5Zm8.75 1.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"/></svg>',
    facebook:
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13.5 22v-8h2.75l.41-3H13.5V9.08c0-.87.24-1.46 1.58-1.46h1.69V4.94c-.29-.04-1.3-.13-2.47-.13-2.44 0-4.11 1.49-4.11 4.22V11H7.43v3h2.76v8h3.31Z"/></svg>',
    linkedin:
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5.34 3.5A1.84 1.84 0 1 1 5.33 7.18 1.84 1.84 0 0 1 5.34 3.5ZM3.75 8.5h3.18V20H3.75V8.5Zm5.15 0h3.05v1.57h.04c.42-.8 1.46-1.65 3-1.65 3.21 0 3.8 2.11 3.8 4.86V20h-3.18v-5.96c0-1.42-.03-3.25-1.98-3.25-1.98 0-2.28 1.55-2.28 3.15V20H8.9V8.5Z"/></svg>',
  };

  const syncSocialLinks = () => {
    const container = document.querySelector('.stark-footer__social');

    if (!container || container.dataset.starkSocialEnhanced === 'true') return;

    const profiles = [
      { key: 'instagram', label: 'Instagram' },
      { key: 'facebook', label: 'Facebook' },
      { key: 'linkedin', label: 'LinkedIn' },
    ].filter(({ key }) => Boolean(config[key]));

    if (!profiles.length) return;

    container.replaceChildren();

    profiles.forEach(({ key, label }) => {
      const link = document.createElement('a');
      link.href = config[key];
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.title = label;
      link.setAttribute('aria-label', label);
      link.innerHTML = socialIcons[key];
      container.append(link);
    });

    container.dataset.starkSocialEnhanced = 'true';
  };

  const readCurrentSku = () => {
    const variantData = document.querySelector('variant-picker script[type="application/json"]');

    if (variantData?.textContent) {
      try {
        return JSON.parse(variantData.textContent)?.sku || '';
      } catch (error) {
        console.warn('[Stark enhancements] Could not read the selected variant SKU.', error);
      }
    }

    return config.initialSku || '';
  };

  const syncProductSku = () => {
    const productDetails = document.querySelector('.product-details');
    const title = productDetails?.querySelector('h1');

    if (!productDetails || !title) return;

    const titleContainer = title.closest('.text-block') || title.parentElement;

    if (!titleContainer?.parentElement) return;

    let row = productDetails.querySelector('[data-stark-product-sku]');

    if (!row) {
      row = document.createElement('div');
      row.className = 'stark-product-sku';
      row.dataset.starkProductSku = 'true';
      row.innerHTML =
        '<span class="stark-product-sku__label">SKU:</span><span class="stark-product-sku__value"></span>';
      titleContainer.insertAdjacentElement('afterend', row);
    }

    const sku = readCurrentSku();
    const value = row.querySelector('.stark-product-sku__value');

    if (value && value.textContent !== sku) {
      value.textContent = sku;
    }

    const shouldHide = !sku;

    if (row.hidden !== shouldHide) {
      row.hidden = shouldHide;
    }
  };

  let syncScheduled = false;

  const scheduleSync = () => {
    if (syncScheduled) return;

    syncScheduled = true;

    requestAnimationFrame(() => {
      syncScheduled = false;
      syncProductSku();
      syncSocialLinks();
    });
  };

  scheduleSync();
  document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });

  const mainContent = document.querySelector('#MainContent') || document.body;
  new MutationObserver(scheduleSync).observe(mainContent, {
    subtree: true,
    childList: true,
    characterData: true,
  });

  new MutationObserver(syncSocialLinks).observe(document.body, {
    subtree: true,
    childList: true,
  });
})();
